import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import type { BlockRenderProps } from '../../types';

export function PopUpTicketPurchaseCard({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const eventTitle = pickBlockField(block.content, 'eventTitle', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const dateLabel = pickBlockField(block.content, 'dateLabel', locale);
  const price = pickBlockField(block.content, 'price', locale);
  const ctaLabel = pickBlockField(block.content, 'ctaLabel', locale);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-popup-ticket', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="tickets"
    >
      <div className="ws-popup-ticket__inner">
        <EditableContent
          as="h2"
          fieldKey="sectionTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-popup-ticket__eyebrow"
        >
          {sectionTitle}
        </EditableContent>
        <EditableContent
          fieldKey="eventTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-popup-ticket__title"
        >
          {eventTitle}
        </EditableContent>
        {dateLabel || editable ? (
          <EditableContent
            fieldKey="dateLabel"
            editable={editable}
            activeEditTarget={target}
            className="ws-popup-ticket__date"
          >
            {dateLabel}
          </EditableContent>
        ) : null}
        <EditableContent
          fieldKey="supporting"
          editable={editable}
          activeEditTarget={target}
          className="ws-popup-ticket__supporting"
        >
          {supporting}
        </EditableContent>
        <div className="ws-popup-ticket__actions">
          {price || editable ? (
            <EditableContent
              fieldKey="price"
              editable={editable}
              activeEditTarget={target}
              className="ws-popup-ticket__price"
            >
              {price}
            </EditableContent>
          ) : null}
          {ctaLabel ? (
            <EditableContent
              as="a"
              fieldKey="ctaLabel"
              editable={editable}
              activeEditTarget={target}
              className="ws-popup-ticket__cta"
              href="#contact"
            >
              {ctaLabel}
            </EditableContent>
          ) : null}
        </div>
      </div>
    </section>
  );
}
